module.exports = __webpack_public_path__ + "static/media/icon_point_right_black.d5998bc1.png";